






import Vue from 'vue'
import { AVAILABLE_CASES, CURRENT_CASE_ID, SET_CURRENT_CASE_ID } from '@/components/Constants'
export default Vue.extend({
  computed: {
    cases() {
      if (this.$store.getters[AVAILABLE_CASES]) {
        return Object.values(this.$store.getters[AVAILABLE_CASES])
      } else {
        return null
      }
    },
    currentCaseId: {
      get() {
        return this.$store.getters[CURRENT_CASE_ID]
      },
      set(value) {
        this.$store.commit({ type: SET_CURRENT_CASE_ID, caseId: value })
      },
    },
  },
})
